import React from "react";

const HamBurgerIcon = ({ fill = "#08080B" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="384pt"
      viewBox="0 -53 384 384"
      width="384pt"
    >
      <path
        d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
        fill={fill}
      />
      <path
        d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
        fill={fill}
      />
      <path
        d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
        fill={fill}
      />
    </svg>
  );
};

export default HamBurgerIcon;
